<template>
  <div>
    <menu-pae />

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item">Interessados</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-md">
      <interessado />
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import interessado from './manageInteressadosRouter.vue'

export default {
  components: {
    menuPae,
    interessado
  }
}
</script>
